import React, { useMemo } from 'react';
import { useAppSelector } from '../app/hooks';
import { OrderingSelectors } from 'polygon-ordering';
import RedcatImage from './RedcatImage';
import MenuItemDescriptions from './MenuItemDescriptions';
import combineStyles from '../utils/combineStyles';
import getThemeLookup from '../selectors/getThemeLookup';
import { CONTAINER_PROPERTIES } from '../utils/theme';
import { AllergenIconList } from './AllergenTagList';

const { getStockBalanceDataByItem, getOpenPurchase, getAllergenDietaryTags } = OrderingSelectors;

const MenuItemMobile = ({
  item,
  availabilityTimeString = '',
}: {
  item: Item;
  availabilityTimeString: string;
}) => {
  const p = useAppSelector(getThemeLookup);
  const stockBalanceData = useAppSelector(
    getStockBalanceDataByItem(item, useAppSelector(getOpenPurchase) as PurchaseWithTotals),
  );
  const checkIfDisabled =
    stockBalanceData && (stockBalanceData.soldOut || stockBalanceData.soldOutByCartSelections);

  const imagePath = useMemo(
    () => item?.images?.default ?? item.sizes.find(s => s.id === item.default_size)?.images.default,
    [item],
  );

  const defaultItemSize = item.sizes.find(s => s.id === item.default_size) ?? item;

  const { dietaryTags } = useAppSelector(state =>
    getAllergenDietaryTags(state, defaultItemSize.tags, false),
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        marginBottom: dietaryTags?.length > 0 && imagePath ? 8 : 52,
      }}
    >
      <div style={{ position: 'relative' }}>
        <RedcatImage
          alt={item.name}
          imagePath={imagePath}
          containerStyle={combineStyles(
            Boolean(checkIfDisabled) && styles.menuItemOpacity,
            styles.imageContainer,
            p('menuItemImage', CONTAINER_PROPERTIES),
          )}
          imageStyle={combineStyles({ borderRadius: 10 }, p('menuItemImage', ['objectFit']))}
        />
        {dietaryTags?.length > 0 && imagePath ? (
          <div style={{ position: 'relative', top: 0, left: 0, maxWidth: 130, minHeight: 40 }}>
            <AllergenIconList item={defaultItemSize} includeTempTags={false} deviceTypeMobile />
          </div>
        ) : (
          <></>
        )}
      </div>
      <div style={{ marginLeft: imagePath ? 20 : 0, flex: 1, overflowX: 'hidden' }}>
        <MenuItemDescriptions
          item={item}
          availabilityTimeString={availabilityTimeString}
          imagePath={imagePath}
        />
      </div>
    </div>
  );
};

export default MenuItemMobile;

const styles = {
  menuItemOpacity: {
    opacity: 0.5,
  },
  imageContainer: {
    height: 130,
    width: 130,
    alignItems: 'flex-start',
  },
};
